var _title, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgArrowDark = function SvgArrowDark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "13px",
    viewBox: "0 0 48 13",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Arrow")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bright-Button",
    transform: "translate(-152.000000, -13.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arrow",
    transform: "translate(23.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(130.000000, 1.714286)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.2597964,5.78557617 C42.5196651,6.04440095 41.8176578,6.38581762 41.1577183,6.81783677 C39.5121422,7.89512238 38.4591312,9.41575245 38,11.3783458 L39.0908063,11.5714286 C39.5883902,9.89832115 40.5076385,8.61082674 41.8472367,7.71032646 C43.1299777,6.84849797 45.0207305,6.40349615 46.9860881,6.36620549 C47.0268413,6.36537681 46.9453349,6.36316699 46.9860881,6.36289077 L46.9860881,5.78557617 L46.9860881,5.21240498 C45.0207305,5.16793242 43.1299777,4.7229306 41.8472367,3.86110211 C40.5076385,2.96032561 39.5883902,1.67310742 39.0908063,0 L38,0.193082728 C38.4591312,2.1553999 39.5121422,3.6763062 41.1577183,4.7535918 C41.8176578,5.18561096 42.5196651,5.5267514 43.2597964,5.78557617 Z",
    id: "Fill-1",
    fill: "#2E3E30"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 45,
    y1: 5.78571429,
    x2: -9.99200722e-15,
    y2: 5.78571429,
    id: "Line",
    stroke: "#2E3E30",
    strokeWidth: 1.25,
    strokeLinecap: "square"
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowDark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow-dark.7444edd5.svg";
export { ForwardRef as ReactComponent };